import { render, staticRenderFns } from "./EmployeesStatistics.vue?vue&type=template&id=d934d598&scoped=true&"
import script from "./EmployeesStatistics.vue?vue&type=script&lang=js&"
export * from "./EmployeesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesStatistics.vue?vue&type=style&index=0&id=d934d598&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d934d598",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VContainer,VDataTable})
